// extracted by mini-css-extract-plugin
export default {"root":"src__components__table__selected-rows-main-action-buttons__root"};